<template>
  <div>
    <v-row justify="center" class="fill-height pa-0" no-gutters>
      <v-card width="100vw" flat class="border-0 mb-0 px-3" style="background: transparent;">
        <v-row class="px-2 px-md-12 mb-0">
          <v-col cols="0" :md="mainDrawerIsMini ? 0 : 3" :lg="mainDrawerIsMini ? 0 : 2">
            <template v-if="isLogged && !isPopupEventsOrSessions">
              <app-drawer
                id="main_menu_drawer"
                name="mainMenu"
                :absolute="true"
                :height="$vuetify.breakpoint.smAndDown? '100vh' :'auto'"
                :app="$vuetify.breakpoint.smAndDown"
                :permanent="$vuetify.breakpoint.mdAndUp"
                :mini-variant="$vuetify.breakpoint.mdAndUp && mainDrawerIsMini"
              />
            </template>
          </v-col>

          <v-col id="mainContent" cols="12" :md="mainDrawerIsMini? 12 : 9" :lg="mainDrawerIsMini? 12 : 10" :class="paddingMenu">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import AppDrawer from '@/components/drawers/AppDrawer'

export default {
  components: {
    AppDrawer
  },
  data () {
    return {
      mainMenuHeight: { minHeight: 100 }
    }
  },
  mounted () {
    setTimeout(() => {
      this.setMainMenuHeight()
    }, 500)
  },
  computed: {
    darkMode () {
      return this.$store.state.ui.darkModeEnabled
    },
    paddingMenu () {
      if (this.mainDrawerIsMini) {
        return 'pl-16 pr-2'
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return 'pl-14'
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        return 'pl-12'
      } else {
        return null
      }
    },
    mainDrawerIsMini () {
      return this.$store.state.drawers.mainIsInMiniVariant
    },
    isLogged () {
      return this.$store.state.auth.isLogged
    },
    isPopupEventsOrSessions () {
      const route = this.$route.path

      return route === '/popup/events' || route === '/popup/sessions'
    }
  },
  methods: {
    setMainMenuHeight () {
      const menu = document.querySelector('#left_drawer aside')
      const mainContentHeight = (menu?.offsetHeight + (menu?.offsetHeight / 14)) || 100
      const mainContent = window.document.getElementById('mainContent')
      mainContent.style.minHeight = `${mainContentHeight}px`
    }
  }
}
</script>
